module.exports = __webpack_public_path__ + "static/media/New_JP.87fad729.svg";